import { createClient } from '@supabase/supabase-js'

// SOLUTION TEMPORAIRE - Remplacez par vos VRAIES valeurs
const supabaseUrl = 'https://aaroeqfjtrnbikrhlohc.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFhcm9lcWZqdHJuYmlrcmhsb2hjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzAyMjEwMTksImV4cCI6MjA4NTc5NzAxOX0.Csk1PnmvfEQAk5nYd5DMM4B-lUseuH29vDPSUEQHz_s'

console.log('🔧 Supabase config:', { supabaseUrl, hasKey: !!supabaseAnonKey })

export const supabase = createClient(supabaseUrl, supabaseAnonKey)